import { useState, useEffect, useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
export var useCustomerInfo = function () {
    var customer = useContext(ExperienceContext).customer;
    var _a = useState(function () {
        var _a;
        return ({
            role: '',
            customerType: ((_a = customer.type) === null || _a === void 0 ? void 0 : _a.toUpperCase()) || '',
            svocID: '',
            userID: '',
        });
    }), customerInfo = _a[0], setCustomerInfo = _a[1];
    useEffect(function () {
        var _a, _b, _c, _d;
        setCustomerInfo({
            role: ((_a = window.THDCustomer) === null || _a === void 0 ? void 0 : _a.default.role) || '',
            customerType: ((_b = window.THDCustomer) === null || _b === void 0 ? void 0 : _b.default.customerType) || '',
            svocID: ((_c = window.THDCustomer) === null || _c === void 0 ? void 0 : _c.default.svocID) || '',
            userID: ((_d = window.THDCustomer) === null || _d === void 0 ? void 0 : _d.default.userID) || '',
        });
    }, []);
    return customerInfo;
};
